import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationFrFr from '@/shared/lang/fr-fr'
import translationBeFr from '@/shared/lang/be-fr'
import translationBeNl from '@/shared/lang/be-nl'
import translationItIt from '@/shared/lang/it-it'
import translationNlNl from '@/shared/lang/nl-nl'
import translationDeDe from '@/shared/lang/de-de'
import translationAtDe from '@/shared/lang/at-de'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    resources: {
      frFr: translationFrFr,
      beFr: translationBeFr,
      beNl: translationBeNl,
      itIt: translationItIt,
      nlNl: translationNlNl,
      deDe: translationDeDe,
      atDe: translationAtDe,
    },
    fallbackLng: 'frFr',
    interpolation: {
      escapeValue: false,
    },
    keySeparator: '.',
  })

export default i18n
